import React, { useState, useEffect, useRef, useContext } from 'react';
import {
    Navigate,
    useLocation,
    useNavigate,
    Link,
  } from "react-router-dom";
import { Play, X } from 'lucide-react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import YoutubeEmbed from '/src/Components/YoutubeEmbed/YoutubeEmbed';
import { WindowSizeContext } from '/src/App';
import './style.css';

const ResourceCard = ({ resource, showTags = true }) => {
    const { deviceType } = useContext(WindowSizeContext);
    const [showVideo, setShowVideo] = useState(false);
    const [videoId, setVideoId] = useState(null);
    const popupRef = useRef(null);
    const navigate = useNavigate();
    const combinedTags = [...resource.associated_climate_risks, ...resource.associated_house_categories];
    const resource_media_type = resource.resource_media_type;

    let resource_image;
    if (resource_media_type === 'blog') {
        resource_image = CreateCloudfrontUrl(resource.image);
    } else if (resource_media_type === 'video') {
        const resource_youtube_id = resource.youtube_id;
        resource_image = 'https://i.ytimg.com/vi/' + resource_youtube_id + '/hqdefault.jpg';
    }

    const handleVideoClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const resource_youtube_id = resource.youtube_id;
        setVideoId(resource_youtube_id);
        setShowVideo(true);
    };

    const handleBlogClick = () => {
        // Scroll to top immediately when blog link is clicked
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Handle click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowVideo(false);
                setVideoId(null);
            }
        };

        if (showVideo) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showVideo]);

    // Create the card content JSX
    const cardContent = (
        <>
            <div className="resource-image-container">
                <img
                    src={resource_image}
                    alt={resource.title}
                    className="resource-image"
                />
                {(resource.video_url || resource.youtube_id) && (
                    <div className="resource-play-icon" onClick={handleVideoClick}>
                        <Play size={24} fill="var(--hub_background)" />
                    </div>
                )}
            </div>
            <div className="resource-content">
                <h4 className="resource-title text-align-center">{resource.title}</h4>
                {showTags && (
                    <div className="resource-tags">
                        <span className="resource-tag">#{resource.category}</span>
                        <span className="resource-tag">#{resource.sub_category}</span>
                        {/* {resource.associated_climate_risks.map((risk, idx) => (
                            <span key={idx} className="resource-tag">#{risk}</span>
                        ))} */}
                        {combinedTags.slice(0, 4).map((category, idx) => (
                            <span key={idx} className="resource-tag">#{category}</span>
                        ))}
                    </div>
                )}
            </div>
        </>
    );

    return (
        <>
            {resource_media_type === 'blog' ? (
                <Link 
                    key={resource.id} 
                    to={`/resources/${resource.slug}`}
                    className="resource-card box-shadow-standard"
                    onClick={handleBlogClick}
                >
                    {cardContent}
                </Link>
            ) : (
                <div 
                    key={resource.id} 
                    className="resource-card box-shadow-standard"
                    onClick={handleVideoClick}
                >
                    {cardContent}
                </div>
            )}

            {showVideo && videoId && (
                <div className="resource-video-overlay">
                    <div className={`resource-video-popup ${deviceType}`} ref={popupRef}>
                        <button 
                            className="resource-video-close"
                            onClick={() => {
                                setShowVideo(false);
                                setVideoId(null);
                            }}
                        >
                            <X size={24} />
                        </button>
                        <YoutubeEmbed embedId={videoId} />
                    </div>
                </div>
            )}
        </>
    );
};

export default ResourceCard;